import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { isToday as isTodayLibrary } from '@/helpers/date-helper';
import { useI18n } from '@/helpers/composables/useI18n';
import { formatDateTime } from '@/helpers/date-helper';
import { faCalendar, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'DateChooser',
  props: {
    displayDate: null
  },
  emits: ["prev", "next", "return", "date"],
  setup(__props: any) {

const props = __props as {
	displayDate: Date;
};

const { tc } = useI18n();





const { language, country } = storeToRefs(useLanguageStore());

const isToday = computed(() => isTodayLibrary(props.displayDate));

const dateDisplay = computed(() => {
	if (isToday.value) {
		return tc('WEBAPP_TODAY');
	}

	return formatDateTime(props.displayDate, language.value, country.value, { day: '2-digit', month: 'short' });
});

const pastDates = computed(() => {
	let pastDates = [];
	for (let i = 1; i <= 3; i++) {
		const selectedDate = new Date(props.displayDate);
		const date = new Date(selectedDate);
		date.setDate(date.getDate() - i);
		pastDates.push({ date: date, shift: -Math.abs(i) });
	}
	return pastDates;
});

const futureDates = computed(() => {
	let futureDates = [];
	for (let i = 1; i <= 3; i++) {
		const selectedDate = new Date(props.displayDate);
		const date = new Date(selectedDate);
		date.setDate(date.getDate() + i);
		futureDates.push({ date: date, shift: Math.abs(i) });
	}
	return futureDates;
});

function getWeekday(date: Date) {
	return formatDateTime(date, language.value, country.value, {
		weekday: 'short',
	});
}

function getDate(date: Date) {
	return formatDateTime(date, language.value, country.value, {
		day: 'numeric',
		month: 'short',
	});
}

return { __sfc: true,tc, props, language, country, isToday, dateDisplay, pastDates, futureDates, getWeekday, getDate, faCalendar, faChevronLeft, faChevronRight }
}

})